import Cookies from "js-cookie";
import { useWecomaIntegration } from "@/shared/composables/wecoma/use-wecoma-integration";
import { useWebStorage } from "@/shared/composables/web-storage/use-web-storage";
import { useWebStorageQueue } from "@/shared/composables/web-storage/use-web-storage-queue";
import { WebStorageJsonType } from "@/shared/model/web-storage-type";
import { CookieType } from "./wecoma/wecoma-models";

const { enqueue } = useWebStorageQueue();

export const useLocalStorage = () => useWebStorage("localStorage");

export const useSessionStorage = () => useWebStorage("sessionStorage");

export const useCookieStorage = () => {
    const { cookieTypeConsentedCached } = useWecomaIntegration();

    const getItem = (name: string) => Cookies.get(name);

    const getJson = <T = WebStorageJsonType>(name: string): T => {
        const val = Cookies.get(name);
        if (val === undefined) {
            return null;
        }

        try {
            return JSON.parse(val);
        } catch {
            return null;
        }
    };

    const setItem = (name: string, value: string, type: CookieType, options?: Cookies.CookieAttributes) => {
        if (!cookieTypeConsentedCached(type)) {
            enqueue({ cookieType: type, itemName: name, storageType: "cookie", value, cookieAttributes: options });
            return false;
        }
        Cookies.set(name, value, { secure: true, ...options });
        return true;
    };

    const setJson = (name: string, value: WebStorageJsonType, type: CookieType, options?: Cookies.CookieAttributes) => {
        const str = JSON.stringify(value);
        return setItem(name, str, type, options);
    };

    const removeItem = (name: string, options?: Cookies.CookieAttributes) => Cookies.remove(name, options);

    return {
        getItem,
        getJson,
        setItem,
        setJson,
        removeItem,
    };
};
